import React, { useEffect, useState, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  MyModal,
} from "../../features/RadConnStyle";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { HttpJsonHeader } from "../../features/Environments";

import axios from "axios";

// Table component dependency
import BoostrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import { PageOptions } from "./PageParams";

export const DefaultState = {
  size: "sm",
  show: false,
  fieldId: "",
  fieldName: "",
  columns: [],
  sql: {
    tableName: null,
    fields: [],
    criteriaFields: [],
    criteriaText: "",
    defaultCriteria: "",
    orderBy: [],
    maxRows: 3000,
  },
  action: (e) => {
    alert(e);
  },
};

export default function SearchTypeB(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const [data, setData] = useState([]);

  //----------------------------------------------------------------------
  if (winState == null) {
    setWinState({
      size: "sm",
      show: false,
      fieldId: "",
      fieldName: "",
      columns: [],
      sql: {
        tableName: null,
        fields: [],
        criteriaFields: [],
        criteriaText: "",
        defaultCriteria: "",
        orderBy: [],
        maxRows: 1000,
      },
      action: (e) => {
        alert(e);
      },
    });
  }

  const closeWin = () => {
    setWinState((pv) => {
      return { ...pv, show: false };
    });
  };

  //----------------------------------------------------------------------
  //*
  useEffect(() => {
    if (!winState?.show) return;

    document.removeEventListener("dblclick", null);
    getData();
    return () => {
      document.addEventListener("dblclick", null);
    };
  }, [winState]);
  //----------------------------------------------------------------------
  // const handleDobleClick = useCallback((e)=>{
  //   e.preventDefault();
  //   console.log('SqlSearchType dblclick handle event');
  // }, [winState]);
  //----------------------------------------------------------------------
  const getData = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/web-search-helper/get-data",
        {
          Params: winState.sql,
          User: userDetail,
        },
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data && res.data.data) {
          setData(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  //----------------------------------------------------------------------
  const rowEvents = {
    // onClick : {.....}
    onDoubleClick: (e, row, rowIndex) => {
      e.preventDefault();
      winState.action(row, winState);
    },
  };
  //----------------------------------------------------------------------
  return (
    <MyModal
      show={winState?.show}
      size={winState?.size ? winState.size : "sm"}
      onHide={closeWin}
      backdrop={false}
      centered
    >
      <ModalBodyBlack>
        <BoostrapTable
          bootstrap4
          keyField={winState?.fieldId ?? "id"}
          rowClasses={"table-next-rows-style"}
          data={data}
          columns={winState?.columns ?? []}
          striped
          hover
          condensed
          headerWrapperClasses="headerWrapper"
          wrapperClasses="bs-table-wrapper"
          bordered={true}
          pagination={paginationFactory(PageOptions)}
          filter={filterFactory()}
          rowEvents={rowEvents}
        />
      </ModalBodyBlack>
      <ModalFooterBlack>
        {/* <Button variant="primary" onClick={winState.action} >Get Result</Button>              */}
        <Button variant="danger" onClick={() => closeWin()}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
//----------------------------------------------------------------------

const HBox = styled.div`
  /* padding: 3px; */
  display: flex;
  /* align-items: center; */
`;
